import { DatatableContextProvider } from "@/components/tables/contexts/DatatableContextProvider";
import { DbtJobListingContent } from "./DbtJobListing";

export const DbtJobListing = () => (
  <DatatableContextProvider>
    <DbtJobListingContent />
  </DatatableContextProvider>
);
